export class CopyHelper {
  // eslint-disable-next-line class-methods-use-this
  public static deepCopy<T>(objectToCopy: T): T {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return JSON.parse(JSON.stringify(objectToCopy));
  }

  public static shallowCopy<T>(objectToCopy: T): T {
    return { ...objectToCopy };
  }
}
